import { useEffect } from 'react';
import { addToWishlist } from '../../common/requests';

type AddToWishListListenerProps = {
    organization_id: number;
};

const AddToWishlistListener = ({ organization_id }: AddToWishListListenerProps) => {

    useEffect(() => {
        const handleAddToWishlist = async (event: MessageEvent) => {
            if (event.data && event.data.type === "addToWishList" && event.data.group_ids && event.data.group_ids.length) {
                await addToWishlist(organization_id, event.data.group_ids);
            }
        };

        window.addEventListener("message", handleAddToWishlist, false);

        return () => {
            window.removeEventListener("message", handleAddToWishlist, false);
        };
    }, [organization_id]);

    return null;
};

export default AddToWishlistListener;
